import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { TableBody, TableRow, Table } from "@material-ui/core";
import moment from "moment";
import {
  formatMoneda,
  validaMonto,
  formatoMonto,
  seleccionarCampo,
} from "../../util/varios";
import TablaDeudaContribuyentes from "./tablaDeudaContribuyentes";
import { TableCell } from "@material-ui/core";
import useTableScroll from "../useTableScrollcesar";
import { AgregarPago } from "../modalFormadePago";
import axios from "axios";
import { Dimmer } from "../spinner";

export const RegistrarPago = (props) => {
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const op = require("../../../public/modulos/datos");

  const headCells = [
    { label: "Tipo de Pago", textAlign: "center" },
    { label: "N° de Documento", textAlign: "center" },
    { label: "Nombre del Banco", textAlign: "center" },
    { label: "Monto", textAlign: "center" },
  ];

  const styleInput = {
    backgroundColor: "#ffff",
    color: "#444242",
  };

  const txtCodigo = useRef();
  const txtNombreContri = useRef();
  const txtCedRif = useRef();
  const txtConcepto = useRef();
  const txtEfectivo = useRef();
  const txtFecha = useRef();
  const btnCancela = useRef();
  const btnAcepta = useRef();

  const [mostrar2, setMostrar2] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const numCaja = JSON.parse(localStorage.getItem("numcaja"));
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [habilitado, setHabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [formaPago, setFormaPago] = useState([]);
  const [montoPorPagar, setMontoPorPagar] = useState(0.0);
  const [montoPagado, setMontoPagado] = useState(0.0);

  const { TblContainer, TblHead } = useTableScroll(headCells);

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth
        );
      }

      if (event.target.id === "inputEfectivo") {
        let totfac = parseFloat(props.factura.totalfactura);
        totfac = Math.round(totfac * Math.pow(10, 2)) / Math.pow(10, 2);
        let mon = parseFloat(
          event.target.value.replace(/\./g, "").replace(",", ".")
        );
        mon = mon + parseFloat(montoPagado);
        mon = Math.round(mon * Math.pow(10, 2)) / Math.pow(10, 2);
        if (mon > totfac) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto:
              "El Monto Efectivo mas los Otros Pagos es Mayor al Monto Total de la Factura.",
            icono: "informacion",
          });
          event.target.value = "0,00";
          txtEfectivo.current.focus();
        }
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    let totfac = parseFloat(props.factura.totalfactura);
    totfac = Math.round(totfac * Math.pow(10, 2)) / Math.pow(10, 2);
    let mon = parseFloat(
      txtEfectivo.current.value.replace(/\./g, "").replace(",", ".")
    );
    mon = mon + parseFloat(montoPagado);
    mon = Math.round(mon * Math.pow(10, 2)) / Math.pow(10, 2);
    if (mon != totfac) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Monto Pagado es Diferente al Monto Total de la Factura.",
        icono: "informacion",
      });
      sigue = false;
      txtEfectivo.current.value = "0,00";
      txtEfectivo.current.focus();
    } else if (txtNombreContri.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Nombre del Representante Legal no debe ir Vacio",
        icono: "informacion",
      });
      sigue = false;
      txtNombreContri.current.value = "";
      txtNombreContri.current.focus();
    } else if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "La Fecha es Invalida",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.value = "";
      txtFecha.current.focus();
    } else if (sigue) {
      var det = [];
      for (let i = 0; i < formaPago.length; i++) {
        det.push({
          fechadoc: formaPago[i].fechadoc,
          numdocumento: formaPago[i].numdocumento,
          monto: formaPago[i].monto,
          tipopago: formaPago[i].idtipopago,
          destipopago: formaPago[i].destipopago,
          idbanco: formaPago[i].idbanco,
          nombanco: formaPago[i].nombanco,
          idcuentabancaria: formaPago[i].idcuentabancaria,
          cuentabanco: formaPago[i].cuentabanco,
        });
      }

      det.push({
        fechadoc: null,
        numdocumento: "",
        monto: txtEfectivo.current.value.replace(/\./g, "").replace(",", "."),
        tipopago: 0,
        destipopago: "EFECTIVO",
        idbanco: 0,
        nombanco: "",
        idcuentabancaria: 0,
        cuentabanco: null,
      });
      let body = {
        fechapag: txtFecha.current.value,
        ncaja: numCaja,
        porcedes: 0.0,
        fechasis: fechaSistema,
        idfact: props.factura.idfactura,
        cajadet: JSON.stringify(det),
        tdeuda: JSON.stringify(props.deuda),
        verifi: JSON.stringify(props.verificacion),
      };

      procesarPago(body);
      //setMensaje({ mostrar: true, titulo: 'Confirmación.', texto: JSON.stringify(body), icono: 'confirmacion' });
    }
  };

  const gestionarPago = (op, id) => (e) => {
    let totfac = parseFloat(props.factura.totalfactura);
    totfac = Math.round(totfac * Math.pow(10, 2)) / Math.pow(10, 2);
    let mon = parseFloat(
      txtEfectivo.current.value.replace(/\./g, "").replace(",", ".")
    );
    mon = Math.round(mon * Math.pow(10, 2)) / Math.pow(10, 2);
    let dife = totfac - mon - parseFloat(montoPagado);
    dife = Math.round(dife * Math.pow(10, 2)) / Math.pow(10, 2);
    setMontoPorPagar(dife);
    if (dife > 0) {
      if (op === 1) {
        setOperacion(1);
        setMostrar2(true);
      } else if (op === 3) {
        setOperacion(op);
        /* seleccionarRegistros(id); */
      }
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El monto pagado es igual al monto facturado",
        icono: "informacion",
      });
    }
  };

  const cancelar = (e) => {
    e.preventDefault();
    setFormaPago([]);
    setMontoPagado(0.0);
    props.onHideCancelar();
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    setFormaPago([]);
    setMontoPagado(0.0);
    props.onHideRenderizar();
    props.onHideCancelar();
  };

  const handleCancela2 = () => {
    setMostrar2(false);
  };

  const handleAceptaPago = (datos) => {
    setMostrar2(false);
    var pago = [];
    let monpag = 0.0;
    for (let i = 0; i < formaPago.length; i++) {
      pago.push({
        fechadoc: formaPago[i].fechadoc,
        numdocumento: formaPago[i].numdocumento,
        monto: formaPago[i].monto,
        idtipopago: formaPago[i].idtipopago,
        destipopago: formaPago[i].destipopago,
        idbanco: formaPago[i].idbanco,
        nombanco: formaPago[i].nombanco,
        idcuentabancaria: formaPago[i].idcuentabancaria,
        cuentabanco: formaPago[i].cuentabanco,
      });
      monpag = monpag + parseFloat(formaPago[i].monto);
    }

    pago.push({
      fechadoc: datos[0].fechadoc,
      numdocumento: datos[0].numdocumento,
      monto: datos[0].monto.replace(/\./g, "").replace(",", "."),
      idtipopago: datos[0].idtipopago,
      destipopago: datos[0].destipopago,
      idbanco: datos[0].idbanco,
      nombanco: datos[0].nombanco,
      idcuentabancaria: datos[0].idcuentabancaria,
      cuentabanco: datos[0].cuentabanco,
    });

    monpag =
      monpag + parseFloat(datos[0].monto.replace(/\./g, "").replace(",", "."));
    monpag = Math.round(monpag * Math.pow(10, 2)) / Math.pow(10, 2);
    setMontoPagado(monpag);
    setFormaPago(pago);
  };

  const imprimirPlanilla = (idfactura) => {
    var reporte = "reciboPagoTMP";
    window.open(
      op.reportes + "reporte=" + reporte + "&factura=" + idfactura,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  const procesarPago = (body) => {
    let endpoint = `${op.conexion}/api/Caja_Ingreso/pagarfactura`;
    setActivate(true);

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        setActivate(false);
        if (response.status == 200) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto:
              "La Transacción N°: " +
              response.data.numtransa +
              " fue Procesada",
            icono: "exito",
          });
          imprimirPlanilla(body.idfact);
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        btnAcepta.current.focus();
        txtCodigo.current.value =
          props.factura.idcontribuyente !== "0"
            ? props.factura.idcontribuyente
            : "";
        txtCedRif.current.value = props.factura.cedrif;
        txtNombreContri.current.value = props.factura.nombrecontri;
        txtConcepto.current.value = props.factura.descripcion;
        setOperacion(props.operacion);
        if (txtCodigo.current.value !== "") {
          let impu = 0.0;
          let inte = 0.0;
          let reca = 0.0;
          let mult = 0.0;
          let totdeu = 0.0;
          let totfac = 0.0;
          for (let i = 0; i < props.deuda.length; i++) {
            impu = parseFloat(impu) + parseFloat(props.deuda[i].monto);
            inte = parseFloat(inte) + parseFloat(props.deuda[i].intereses);
            reca = parseFloat(reca) + parseFloat(props.deuda[i].recargo);
            mult = parseFloat(mult) + parseFloat(props.deuda[i].multa);
          }
          totdeu =
            parseFloat(impu + inte + reca + mult) -
            parseFloat(props.factura.deducible);
          totdeu = Math.round(totdeu * Math.pow(10, 2)) / Math.pow(10, 2);
          totfac = parseFloat(props.factura.totalfactura);
          totfac = Math.round(totfac * Math.pow(10, 2)) / Math.pow(10, 2);
          if (totdeu !== totfac) {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto:
                "No se puede procesar la transacción Hay diferencia entre el monto facturado y la deuda actual",
              icono: "informacion",
            });
            setDeshabilitado(true);
            setHabilitado(true);
          } else {
            setDeshabilitado(false);
            setHabilitado(false);
          }
        } else {
          setDeshabilitado(false);
          setHabilitado(false);
        }
        if (props.verificacion.length > 0) {
          var pago = [];
          let monpag = 0.0;
          for (let i = 0; i < props.verificacion.length; i++) {
            pago.push({
              fechadoc: props.verificacion[i].fecha,
              numdocumento: props.verificacion[i].nrodocumento,
              monto: props.verificacion[i].monto,
              idtipopago: props.verificacion[i].tipo === 1 ? 3 : 2,
              destipopago:
                props.verificacion[i].tipo === 1 ? "DEPOSITO" : "TRANSFERENCIA",
              idbanco: props.verificacion[i].idbanco,
              nombanco: props.verificacion[i].nombre,
              idcuentabancaria: props.verificacion[i].idcuentabancaria,
              cuentabanco: props.verificacion[i].cuentabancaria,
            });
            monpag = monpag + parseFloat(props.verificacion[i].monto);
          }

          //monpag = monpag + parseFloat(datos[0].monto.replace(/\./g, '').replace(',', '.'));
          monpag = Math.round(monpag * Math.pow(10, 2)) / Math.pow(10, 2);
          setMontoPagado(monpag);
          setFormaPago(pago);
          setDeshabilitado(true);
          setHabilitado(false);
        }
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>
            {props.operacion === 1
              ? "Caja."
              : props.operacion === 2
              ? "Caja."
              : props.operacion === 3
              ? "Caja."
              : "Caja."}
          </h3>
        </div>
        <button
          ref={btnCancela}
          className="btn bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#FFF", color: "" }}>
        <AgregarPago
          show={mostrar2}
          operacion={operacion}
          fecha={props.fecha}
          totalfactura={props.factura ? props.factura.totalfactura : "0.00"}
          porpagar={montoPorPagar}
          onHideCancela={handleCancela2}
          onHideAcepta={handleAceptaPago}
        />

        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} />
        <div
          className="titulos"
          style={{
            height: "auto",
            minHeight: "auto",
            maxHeight: "90vh",
            overflow: "auto",
          }}
        >
          <div className="container">
            <fieldset className="row border-azul rounded mx-auto">
              <legend className="float-none m-0 w-auto">
                Datos de la Factura
              </legend>
              <div className="col-md-12 row m-0">
                <div className="col-sm-2 col-12 px-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Código:
                    </label>
                    <input
                      type="text"
                      disabled
                      ref={txtCodigo}
                      className="form-control bg-light"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      name="fecha"
                    />
                  </div>
                </div>
                <div className="col-sm-2 oculto"></div>
                <div className="col-sm-4 col-12 px-2">
                  <div className="input-group input-group-sm px-5">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Cédula o RIF:
                    </label>
                    <input
                      type="text"
                      disabled
                      ref={txtCedRif}
                      autoComplete="off"
                      className="form-control bg-light"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      name="fecha"
                    />
                  </div>
                </div>
                <div className="col-sm-2 oculto"></div>
                <div className="col-sm-2 col-12 px-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Fecha:
                    </label>
                    <input
                      type="date"
                      ref={txtFecha}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      name="fecha"
                      defaultValue={
                        props.fecha
                          ? props.fecha !== null
                            ? moment(props.fecha).format("YYYY-MM-DD")
                            : ""
                          : moment(fechaSistema).format("YYYY-MM-DD")
                      }
                      id="inputFecha"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-12 row m-0 py-1">
                <div className="col-sm-6 col-12 px-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Nombre del Contribuyente:
                    </label>
                    <input
                      type="text"
                      disabled
                      ref={txtNombreContri}
                      autoComplete="off"
                      className="form-control bg-light"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      name="fecha"
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-12 px-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Concepto:
                    </label>
                    <input
                      type="text"
                      disabled
                      ref={txtConcepto}
                      autoComplete="off"
                      className="form-control bg-light"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      name="fecha"
                    />
                  </div>
                </div>
              </div>
            </fieldset>
            <div className="col-md-12 py-1"></div>
            <fieldset className="border-azul rounded">
              <legend className="float-none m-0 w-auto">
                Deuda del Contribuyente
              </legend>
              <div className="p-0">
                <TablaDeudaContribuyentes
                  factura={props.factura}
                  deuda={props.deuda}
                />
              </div>
            </fieldset>
            <div className="col-md-12 py-1"></div>
            <fieldset className="border-azul rounded row m-0">
              <legend className="float-none m-0 w-auto">Tipos de Pagos</legend>
              <div className="col-md-12 px-0">
                <div className="col-sm-3 px-0 py-1">
                  <div className="input-group input-group-sm">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Monto en Efectivo:
                    </label>
                    <input
                      type="text"
                      disabled={deshabilitado}
                      autoComplete="off"
                      ref={txtEfectivo}
                      className="form-control text-right"
                      placeholder="0,00"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputEfectivo"
                      defaultValue="0,00"
                      onFocus={seleccionarCampo}
                      onKeyUp={handleInputMontoChange}
                      onBlur={handleInputMontoChange}
                      style={styleInput}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-11 col-12 px-0">
                <TblContainer
                  container={{
                    height: 110,
                    maxHeight: 180,
                    width: "100%",
                    overflow: "auto",
                  }}
                >
                  <TblHead />
                  <TableBody>
                    {formaPago &&
                      formaPago.map((fpago, index) => (
                        <TableRow key={index}>
                          <TableCell className="p-0 text-center">
                            {fpago.destipopago}
                          </TableCell>
                          <TableCell className="p-0 text-center">
                            {fpago.numdocumento}
                          </TableCell>
                          <TableCell className="p-0 text-end">
                            {fpago.nombanco}
                          </TableCell>
                          <TableCell className="p-0 text-end">
                            {formatMoneda(
                              fpago.monto.replace(",", "").replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </TblContainer>
                <div
                  className="row col-md-4 col-12 p-0 m-0 border-table ml-auto"
                  style={{ borderTopStyle: "hidden" }}
                >
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell className="text-right">
                          <p className="fw-bold">
                            {"Monto: " +
                              formatMoneda(
                                montoPagado
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                          </p>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </div>
              </div>
              <div className="col-md-1 row m-auto col-12">
                <div className="col-md-12 col-4 py-2 px-4">
                  <button
                    disabled={deshabilitado}
                    onClick={gestionarPago(1, "")}
                    className="btn btn-sm btn-info rounded-circle"
                  >
                    <i className="fas fa-plus"></i>{" "}
                  </button>
                </div>
                <div className="col-md-12 col-4 py-2 px-4">
                  <button
                    disabled={deshabilitado}
                    className="btn btn-sm btn-warning rounded-circle"
                  >
                    <i className="fas fa-pencil-alt"></i>{" "}
                  </button>
                </div>
                <div className="col-md-12 col-4 py-2 px-4">
                  <button
                    disabled={deshabilitado}
                    className="btn btn-sm btn-danger rounded-circle"
                  >
                    <i className="fa fa-trash"></i>{" "}
                  </button>
                </div>
              </div>
            </fieldset>

            <div className="col-sm-12 py-1 d-flex justify-content-end  align-items-center">
              <button
                ref={btnAcepta}
                disabled={habilitado}
                onClick={onChangeValidar}
                className="btn btn-sm rounded-pill btn-success col-md-2"
              >
                <i className="fas fa-check-circle"> Aceptar</i>
              </button>
              <button
                ref={btnCancela}
                onClick={cancelar}
                className="btn btn-danger btn-sm rounded-pill col-md-2"
              >
                <i className="fas fa-window-close"> Cancelar</i>
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/ingresos/modalRegistrarPago.js